import { h } from 'preact'
import UserAvatar from '../User/UserAvatar'
import { AuthorFromServer } from '@insided/control/modules/ContentModeration/TopicModeration/interfaces'

const PostAuthor = ({ author }: { author: AuthorFromServer }) => {
  return (
    <UserAvatar
      user={{ ...author, ...{ name: author.username } }}
      extraClass='avatar avatar--responsive'
      showRank
    />
  )
}

export default PostAuthor
